import { FilterButtonWithMobileDrawer } from 'components/search/v2/Filter/FilterButtonWithMobileDrawer';
import { useAtom, useAtomValue } from 'jotai';
import {
  priceAtom,
  isPriceFilterActiveAtom,
  getDefaultPriceAtomVal,
  priceTempAtom,
} from 'components/search/v2/Filter/filterStore';
import PriceLabel from 'components/search/v2/Filter/contents/PriceFilterContent';
import AtomSlider from 'components/search/v2/Filter/fields/AtomSlider';
import useMediaQuerySafe from 'hooks/useMediaQuerySafe';
import { getMaxQueryWidth } from 'helpers/breakpoints';
import { breakpoints } from 'components/search/v2/styleConstants';
import { useEffect, useMemo } from 'react';
import { duplicateSliderAtom } from 'components/search/v2/Filter/filterAtomUtils';

const PriceFilterButton = (props) => {
  const { toggleFilterDropdown, name } = props;
  const isMobile = useMediaQuerySafe(getMaxQueryWidth(breakpoints.QUICK_FILTER_BOTTOM_SHEET_MAX));
  const [tempPrice, setTempPrice] = useAtom(priceTempAtom);
  const [price, setOGPrice] = useAtom(priceAtom);
  const priceValue = useAtomValue(price.valueAtom);
  const ogDupedPriceVal = useAtomValue(useMemo(() => duplicateSliderAtom(priceAtom), []));

  const onClear = () => {
    const newPriceVal = getDefaultPriceAtomVal();
    setTempPrice(newPriceVal);
  };
  const onShowResults = () => {
    setOGPrice(tempPrice);
    toggleFilterDropdown(null);
  };

  useEffect(() => {
    if (isMobile) {
      setTempPrice(ogDupedPriceVal);
    }
  }, [priceValue]);

  return (
    <FilterButtonWithMobileDrawer
      {...props}
      name={name}
      title="Price"
      label={<PriceLabel />}
      content={<AtomSlider atom={isMobile ? priceTempAtom : priceAtom} />}
      onClear={onClear}
      onShowResults={onShowResults}
      isFilterActiveAtom={isPriceFilterActiveAtom}
      toggleDropdown={toggleFilterDropdown}
      disabled={false}
    />
  );
};

export default PriceFilterButton;
